const initialState = {
    list: [],
    error: {}
};

const ApplicationNameReducer = (state, action) => {
    if (state === null || state === undefined) {
        state = initialState;
    }
    switch (action.type) {
        case "GET_APPLICATION_NAME_SUCCESS":
            state = {
                ...state,
                list: [...action.payload]

            };
            return state;
        case "GET_APPLICATION_NAME_ERROR":
            state = {
                ...state,
                error: action.payload
            };
            return state;
        default:
            return state;
    }
};

export default ApplicationNameReducer;
